module.exports = __webpack_public_path__ + "img/img_network.5a0bd0a9.svg";